'use strict';

import angular from 'angular';
import ShowController from './show.controller';

export default angular.module('onyxReadingRoomApp.jdOrder.show', [])
  .controller('JdOrderShowController', ShowController)
  .name;



// WEBPACK FOOTER //
// ./client/app/jdOrder/show/index.js